import {NavList} from '@primer/react'

import type {StackSectionEntryType} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import {getStackEntryLineClass} from '../../../helpers/get-stack-entry-line-class'
import {useStackMergeabilityUpdates} from '../../../hooks/use-stack-mergeability-updates'
import {EffectiveEntryStatusLabel} from './EffectiveEntryStatusLabel'
import {useStackRebaseStatus} from '../../../hooks/mutations/use-stack-rebase-mutation'
import {EffectiveEntryStatusIcon} from './EffectiveEntryStatusIcon'
import {determineEffectiveEntryStatus} from '../../../helpers/determine-effective-entry-status'

export function StackEntryNavItem({
  entry,
  previousEntry,
  tabSuffix,
}: {
  entry: StackSectionEntryType
  previousEntry?: StackSectionEntryType
  tabSuffix: string
}) {
  const {isRebasing} = useStackRebaseStatus()
  // Temporary solution until this is upstreamed to StackSectionStatus#entries.
  const effectiveEntryStatus = determineEffectiveEntryStatus(entry, isRebasing)

  useStackMergeabilityUpdates({basePageDataUrl: entry.pull.url, channels: entry.channels})

  return (
    <NavList.Item
      href={`${entry.pull.url}${tabSuffix}`}
      aria-current={entry.position === 'CURRENT'}
      className={getStackEntryLineClass(entry, undefined, previousEntry, undefined)}
    >
      <NavList.LeadingVisual>
        <EffectiveEntryStatusIcon status={effectiveEntryStatus} />
      </NavList.LeadingVisual>
      <span className={entry.position === 'AFTER' ? 'fgColor-muted' : ''}>{entry.pull.title}</span>
      <NavList.Description variant="block">
        <span className="fgColor-muted">
          #{entry.pull.number} · {entry.pull.headBranch}
        </span>
      </NavList.Description>
      <NavList.TrailingVisual>
        <EffectiveEntryStatusLabel status={effectiveEntryStatus} />
      </NavList.TrailingVisual>
    </NavList.Item>
  )
}
